import { SlideHeader } from 'components/Shared';
import { useStackableBreadcrumbs } from 'components/Shared/StackedContent/StackableContentContext';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ProductJourneyPages } from '../pages';
import styled from 'styled-components';
import BatchTracing from 'components/Shared/BatchTracingContainer/BatchTracing';
import Header from './Header';
const ScrollContainer = styled.div `
  z-index: 1;
  position: relative;
  height: 100%;
  overflow: auto;
  /* Workaround to fix parents container min-height requirement which overflows the container and hides part of the scrollbar */
  padding-bottom: 30px;

  ${({ isMobile }) => isMobile &&
    `
    min-height: 200px;
    height: calc(100vh - 32px);
  `}
`;
const TracingContainer = styled.div `
  padding: 0 16px 16px;
`;
const MobileBatchDetailsSlide = ({ activeStepActivity, selectedRawMaterial, hasOtherIngredients, isSelectedActivityTraceable, isSelectedStepTraceable, }) => {
    const breadcrumbs = useStackableBreadcrumbs();
    const isMobile = true;
    const { t } = useTranslation();
    const scrollRef = useRef();
    const activity = activeStepActivity.activity;
    return (React.createElement(React.Fragment, null,
        React.createElement(SlideHeader, { mobile: true, breadcrumbs: breadcrumbs, labelBackLink: t('back-to-location'), backToStartCrumb: { type: ProductJourneyPages.PRODUCT_JOURNEY } }),
        React.createElement(ScrollContainer, { ref: scrollRef, isMobile: isMobile },
            React.createElement(Header, { activity: activity, isActive: true }),
            React.createElement(TracingContainer, null,
                React.createElement(BatchTracing, { hasOtherIngredients: hasOtherIngredients, rawMaterial: selectedRawMaterial, batchTracingActive: true, notTraceableActivity: !isSelectedActivityTraceable, notTraceableStep: !isSelectedStepTraceable, chainStepActivity: activeStepActivity, hideLocationPin: true })))));
};
export default MobileBatchDetailsSlide;
